//Class qui contient les fontions par défaut des scènes.

import { tags } from '../consts/Tags.js'
import { Colors } from '../consts/Colors.js';

export default class AbstractScene extends Phaser.Scene {

    //Initialisation par défaut, à ajouter dans tous les initialisation
    //Data contient les info des transitions (cf onCompleteHandlerTransitionOUT)
    _init(data) {
        console.log('Start :', this.scene.key, data);
        this.data = {};

        this.game.data.sceneRunning = this.scene.key;


        if (data) {
            // Data à faire passer au besoin
        }
    }

    //Preload de la scene par défaut, initialise les variables utiles
    _preload() {
        this.load.audio('click', 'assets/audios/clic.mp3');

        this.width = this.cameras.main.width; //Largeur de l'écran
        this.height = this.cameras.main.height; //Hauter de l'écran

        this.dim = this.height * 0.05; //Variable pour adapter les images à la hauteur
        this.ratio = Math.min(this.width / 1920, this.height / 1080); //Ratio de l'écran
    }

    nextScene() {
        var sceneInfo = this.game.data[this.game.data.sceneRunning];
        this.scene.start(sceneInfo.next, this.data);
    }

    clone(element) {
        var clone = Phaser.Utils.Objects.Clone(element)
        this.add.existing(clone)
        return clone
    }

    createTextElement(x, y, element) {
        let txt = this.add.rexTagText(x, y, element.text, {
            fontSize: element.config.size,
            fontFamily: element.config.fontFamily,
            align: element.config.align,
            color: element.config.color,
            backgroundColor: element.config.backColor,
            wordWrap: { width: element.config.width },
            tags: tags
        }).setOrigin(element.config.origin.x, element.config.origin.y);
        return txt
    }

    createBulletList(bulletList, x, y, container, isSpaced = false, index, bulletListArray) {
        let bulletSpace = 30
        for (let i = 0; i < bulletList.length; i++) {
            const element = bulletList[i];
            let bullet = this.add.circle(x, y + bulletSpace * i, 4).setFillStyle(Colors.Elmt.Black);
            container.add(bullet);
            let bulletText = this.createTextElement(x + 30, y + bulletSpace * i - 10, element);
            container.add(bulletText);
            if (bulletListArray) {
                bulletListArray.push(bullet)
                bulletListArray.push(bulletText)
            }
            if (isSpaced) {
                if (i !== index) {
                    bullet.y += 25;
                    bulletText.y += 25;
                }
            }
            if (element.isLong) {
                bullet.y += 25;
                bulletText.y += 25;
            }

        }
    }

    addHeader(title) {
        this.clickSound = this.sound.add('click', { volume: 0.4 });
        this.thirdRect = this.add.rexRoundRectangle(-665, 40, 665, 60, { tl: 0, tr: 15, bl: 0, br: 15 }, Colors.Elmt.lightBlue).setOrigin(0)
        this.secondRect = this.add.rexRoundRectangle(-620, 40, 620, 60, { tl: 0, tr: 15, bl: 0, br: 15 }, Colors.Elmt.MidBlue).setOrigin(0)
        this.firstRect = this.add.rexRoundRectangle(-570, 40, 570, 60, { tl: 0, tr: 15, bl: 0, br: 15 }, Colors.Elmt.MainBlue).setOrigin(0)
        this.title = this.add.rexTagText(60, 70, title, {
            fontSize: "26px",
            fontFamily: "DKButterfly",
            align: 'left',
            color: Colors.Text.White,
            backgroundColor: "transparent",
        }).setOrigin(0, 0.5).setAlpha(0);

        this.homeBtn = this.add.image(1817, 48, 'home').setOrigin(0).setAlpha(0).setScale(0)
        this.homeBtn.setInteractive({ useHandCursor: true })
        this.homeBtn.on('pointerover', () => {
            this.homeBtn.setScale(1.1);
        })
        this.homeBtn.on('pointerout', () => {
            this.homeBtn.setScale(1);
        })
        this.homeBtn.on('pointerdown', () => {
            this.clickSound.play();
            this.scene.start('Menu');
        })

        this.soundManager(1870, 55)
        this.audioBtn.setAlpha(0)
        this.audioBtnSlash.setAlpha(0)

        this.tweens.add({
            targets: this.thirdRect,
            x: 0,
            duration: 500,
            ease: 'Power2',
        })
        this.tweens.add({
            targets: this.secondRect,
            x: 0,
            duration: 500,
            ease: 'Power2',
            delay: 100
        })
        this.tweens.add({
            targets: this.firstRect,
            x: 0,
            duration: 500,
            ease: 'Power2',
            delay: 200,
            onComplete: () => {
                this.tweens.add({
                    targets: [this.title],
                    alpha: 1,
                    duration: 200,
                    ease: 'Power2',
                })
                this.tweens.add({
                    targets: [this.homeBtn],
                    alpha: 1,
                    scale: 1,
                    duration: 200,
                    ease: 'Power2',
                    onComplete: () => {
                        this.launchScene()
                    }
                })
                this.tweens.add({
                    targets: [this.audioBtn],
                    alpha: 1,
                    duration: 200,
                    ease: 'Power2',
                    onComplete: () => {
                    }
                })
                if (this.game.data.isMuted) {
                    this.tweens.add({
                        targets: [this.audioBtnSlash],
                        alpha: 1,
                        duration: 200,
                        ease: 'Power2',
                        onComplete: () => {
                        }
                    })
                }
            }
        })
    }

    addSounds() {
        this.sounds = {
            pop: this.sound.add('pop', { volume: 0.1 }),
            whoosh: this.sound.add('whoosh', { volume: 0.3 }),
            win: this.sound.add('win', { volume: 0.3 }),
            lose: this.sound.add('lose', { volume: 0.2 }),
            interference: this.sound.add('interference', { volume: 0.05 }),
        };
    }

    playSound(soundName) {
        if (this.sounds[soundName]) {
            this.sounds[soundName].play();
            console.log('Son joué dans Phaser:', soundName);
        }
    }

    addBackgroundMusique(audioKey) {
        // Arrêter la musique précédente si elle existe
        if (this.game.data.backgroundMusic) {
            this.game.data.backgroundMusic.stop();
        }
        this.backgroundMusic = this.sound.add(audioKey, { volume: 0.1, loop: true });
        this.game.data.backgroundMusic = this.backgroundMusic;
        this.backgroundMusic.play();
    }

    soundManager(x, y) {
        this.isMuted = this.game.data.isMuted;
        this.audioBtn = this.add.image(x, y, 'volume').setOrigin(0).setScale(0.2);
        this.audioBtnSlash = this.add.rectangle(x, y + 32, 50, 5, Colors.Elmt.Black).setOrigin(0).setAngle(-45).setAlpha(this.isMuted ? 1 : 0);
        this.audioBtn.setInteractive({ useHandCursor: true });
        this.audioBtn.on('pointerdown', () => {
            this.isMuted = !this.isMuted;
            this.sound.mute = this.isMuted;
            if (this.isMuted) {
                this.audioBtnSlash.setAlpha(1);
                this.game.data.isMuted = true;
            } else {
                this.audioBtnSlash.setAlpha(0);
                this.game.data.isMuted = false;
            }
        });
    }
}